(() => {
  const SHOW_MORE_LIMIT = 5;
  const CUSTOM_FILTER_PARAMS = {
    color: 'am_color',
    size: 'am_size'
  };
  const filteredItemsCache = new Map();
  let ignoreObserverUntil = 0;
  let currentRenderRequestId = 0;
  let showMoreIdCounter = 0;

  const TITLE_COLOR_KEYWORDS = [
    { token: 'zeytin yesili', label: 'Zeytin Yeşili' },
    { token: 'kahverengi', label: 'Kahverengi' },
    { token: 'adacayi', label: 'Adaçayı' },
    { token: 'kiremit', label: 'Kiremit' },
    { token: 'kirmizi', label: 'Kırmızı' },
    { token: 'lacivert', label: 'Lacivert' },
    { token: 'turuncu', label: 'Turuncu' },
    { token: 'siyah', label: 'Siyah' },
    { token: 'bordo', label: 'Bordo' },
    { token: 'pudra', label: 'Pudra' },
    { token: 'beyaz', label: 'Beyaz' },
    { token: 'mavi', label: 'Mavi' },
    { token: 'sari', label: 'Sarı' },
    { token: 'gri', label: 'Gri' },
    { token: 'bej', label: 'Bej' },
    { token: 'mor', label: 'Mor' },
    { token: 'yesil', label: 'Yeşil' },
    { token: 'green', label: 'Yeşil' },
    { token: 'blue', label: 'Mavi' },
    { token: 'red', label: 'Kırmızı' },
    { token: 'cream', label: 'Krem' },
    { token: 'white', label: 'Beyaz' },
    { token: 'black', label: 'Siyah' },
    { token: 'brown', label: 'Kahverengi' },
    { token: 'gray', label: 'Gri' },
    { token: 'grey', label: 'Gri' }
  ];

  const normalize = (value = '') =>
    value
      .toString()
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i')
      .trim();

  const normalizeSizeValue = (value = '') => {
    const normalized = normalize(value).replace(/×/g, 'x').replace(/\s+/g, ' ').trim();
    const matchedSize = normalized.match(/^(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)(?:\s*(cm))?$/);

    if (matchedSize) {
      const [, width, height, unit] = matchedSize;
      const resolvedUnit = unit || 'cm';

      return {
        token: `${width}x${height}${resolvedUnit}`,
        label: `${width}x${height} ${resolvedUnit}`,
      };
    }

    return {
      token: normalized.replace(/\s+/g, ''),
      label: value.toString().trim(),
    };
  };

  const splitPipeValues = (value = '') =>
    value
      .split('|')
      .map((item) => item.trim())
      .filter(Boolean);

  const isPhoneViewport = () => window.matchMedia('(max-width: 749px)').matches;

  const syncContainerPlacement = (container) => {
    const sectionId = container.dataset.customFilterSection;
    if (!sectionId) return;

    const desktopHost = document.querySelector(`[data-custom-facets-desktop-host="${sectionId}"]`);
    const mobileHost = document.querySelector(`[data-custom-facets-mobile-host="${sectionId}"]`);
    const targetHost = isPhoneViewport() && mobileHost ? mobileHost : desktopHost;

    if (!targetHost || container.parentElement === targetHost) return;
    targetHost.appendChild(container);
  };

  const collectItemsForContainer = (container) => {
    const sectionId = container.dataset.customFilterSection;
    if (!sectionId) return [];

    const productGrid = document.querySelector(`#product-grid[data-id="${sectionId}"]`);
    if (!productGrid) return [];

    return Array.from(productGrid.querySelectorAll('[data-custom-filter-item]'));
  };

  const collectFilterData = (items) => {
    const availableColors = new Map();
    const availableSizes = new Map();

    items.forEach((item) => {
      const itemColorTokens = new Set();
      const explicitColors = splitPipeValues(item.dataset.customColors || '');

      explicitColors.forEach((colorLabel) => {
        const token = normalize(colorLabel);
        if (!token) return;
        itemColorTokens.add(token);
        if (!availableColors.has(token)) {
          availableColors.set(token, colorLabel);
        }
      });

      if (itemColorTokens.size === 0) {
        const normalizedTitle = normalize(item.dataset.customTitle || '');
        TITLE_COLOR_KEYWORDS.forEach((entry) => {
          if (normalizedTitle.includes(entry.token)) {
            itemColorTokens.add(entry.token);
            if (!availableColors.has(entry.token)) {
              availableColors.set(entry.token, entry.label);
            }
          }
        });
      }

      item.dataset.customColorTokens = Array.from(itemColorTokens).join('|');

      const sizes = splitPipeValues(item.dataset.customSizes || '');
      const normalizedSizeTokens = [];
      sizes.forEach((sizeLabel) => {
        const sizeData = normalizeSizeValue(sizeLabel);
        const token = sizeData.token;
        if (!token) return;
        normalizedSizeTokens.push(token);
        if (!availableSizes.has(token)) {
          availableSizes.set(token, sizeData.label);
        }
      });

      item.dataset.customSizeTokens = normalizedSizeTokens.join('|');
    });

    const colors = Array.from(availableColors.entries())
      .map(([token, label]) => ({ token, label }))
      .sort((left, right) => left.label.localeCompare(right.label, 'tr'));

    const sizes = Array.from(availableSizes.entries())
      .map(([token, label]) => ({ token, label }))
      .sort((left, right) => left.label.localeCompare(right.label, 'tr'));

    return {
      colors,
      sizes
    };
  };

  const getSelectedValues = (container, type) =>
    Array.from(container.querySelectorAll(`input[data-custom-filter-type="${type}"]:checked`)).map(
      (input) => input.value
    );

  const getSelectedValuesFromUrl = (type) => {
    const paramName = CUSTOM_FILTER_PARAMS[type];
    if (!paramName) return [];

    return new URLSearchParams(window.location.search).getAll(paramName).map((value) => {
      if (type === 'size') return normalizeSizeValue(value).token;
      return normalize(value);
    });
  };

  const updateUrlState = (container) => {
    const url = new URL(window.location.href);
    const selectedColorTokens = getSelectedValues(container, 'color');
    const selectedSizeTokens = getSelectedValues(container, 'size');

    url.searchParams.delete(CUSTOM_FILTER_PARAMS.color);
    url.searchParams.delete(CUSTOM_FILTER_PARAMS.size);

    selectedColorTokens.forEach((token) => url.searchParams.append(CUSTOM_FILTER_PARAMS.color, token));
    selectedSizeTokens.forEach((token) => url.searchParams.append(CUSTOM_FILTER_PARAMS.size, token));

    history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`);
  };

  const buildNavigationUrl = (page, selectedColorTokens, selectedSizeTokens) => {
    const url = new URL(window.location.href);

    url.searchParams.delete(CUSTOM_FILTER_PARAMS.color);
    url.searchParams.delete(CUSTOM_FILTER_PARAMS.size);

    selectedColorTokens.forEach((token) => url.searchParams.append(CUSTOM_FILTER_PARAMS.color, token));
    selectedSizeTokens.forEach((token) => url.searchParams.append(CUSTOM_FILTER_PARAMS.size, token));

    if (page > 1) {
      url.searchParams.set('page', String(page));
    } else {
      url.searchParams.delete('page');
    }

    return `${url.pathname}${url.search}${url.hash}`;
  };

  const getCurrentCustomPage = () => {
    const page = Number.parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    return Number.isNaN(page) || page < 1 ? 1 : page;
  };

  const getProductsPerPage = (container) => {
    const value = Number.parseInt(container.dataset.productsPerPage || '', 10);
    return Number.isNaN(value) || value < 1 ? 16 : value;
  };

  const getTotalPages = () => {
    const pageValues = new Set([getCurrentCustomPage()]);

    document.querySelectorAll('.pagination a[href]').forEach((link) => {
      const page = Number.parseInt(new URL(link.href, window.location.origin).searchParams.get('page') || '1', 10);
      if (!Number.isNaN(page) && page > 0) pageValues.add(page);
    });

    const paginationWrapper = document.querySelector('.pagination-wrapper[data-page]');
    if (paginationWrapper) {
      const page = Number.parseInt(paginationWrapper.dataset.page || '1', 10);
      if (!Number.isNaN(page) && page > 0) pageValues.add(page);
    }

    return Math.max(...pageValues);
  };

  const getSectionUrl = (container, page) => {
    const url = new URL(window.location.href);
    const sectionId = container.dataset.customFilterSection;

    url.searchParams.delete(CUSTOM_FILTER_PARAMS.color);
    url.searchParams.delete(CUSTOM_FILTER_PARAMS.size);
    url.searchParams.delete('section_id');

    if (page > 1) {
      url.searchParams.set('page', String(page));
    } else {
      url.searchParams.delete('page');
    }

    url.searchParams.set('section_id', sectionId);

    return `${url.pathname}${url.search}`;
  };

  const getFilterCacheKey = (selectedColorTokens, selectedSizeTokens) => {
    const url = new URL(window.location.href);

    url.searchParams.delete(CUSTOM_FILTER_PARAMS.color);
    url.searchParams.delete(CUSTOM_FILTER_PARAMS.size);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');

    return JSON.stringify({
      path: url.pathname,
      search: url.search,
      color: selectedColorTokens,
      size: selectedSizeTokens,
    });
  };

  const hasActiveFilters = (selectedColorTokens, selectedSizeTokens) =>
    selectedColorTokens.length > 0 || selectedSizeTokens.length > 0;

  const updateProductCounts = (count) => {
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((element) => {
      element.textContent = `${count} ürün`;
    });
  };

  const pauseObserver = (duration = 400) => {
    ignoreObserverUntil = Date.now() + duration;
  };

  const buildPaginationParts = (currentPage, totalPages) => {
    const parts = [];

    for (let page = 1; page <= totalPages; page += 1) {
      const isEdgePage = page === 1 || page === totalPages;
      const isNearCurrent = Math.abs(page - currentPage) <= 1;

      if (isEdgePage || isNearCurrent) {
        parts.push(page);
      } else if (parts[parts.length - 1] !== 'ellipsis') {
        parts.push('ellipsis');
      }
    }

    return parts;
  };

  const renderPagination = (container, totalItems, selectedColorTokens, selectedSizeTokens) => {
    const collection = document.querySelector('#product-grid')?.closest('.collection');
    if (!collection) return;

    collection.querySelector('.pagination-wrapper')?.remove();

    const productsPerPage = getProductsPerPage(container);
    const totalPages = Math.max(1, Math.ceil(totalItems / productsPerPage));
    const currentPage = Math.min(getCurrentCustomPage(), totalPages);

    if (totalPages <= 1) return;

    const parts = buildPaginationParts(currentPage, totalPages);
    const items = [];

    if (currentPage > 1) {
      items.push(`
        <li>
          <a
            href="${buildNavigationUrl(currentPage - 1, selectedColorTokens, selectedSizeTokens)}"
            class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
            aria-label="Önceki sayfa"
          >
            <span class="svg-wrapper">${window.themeIcons?.caret || ''}</span>
          </a>
        </li>
      `);
    }

    parts.forEach((part) => {
      if (part === 'ellipsis') {
        items.push('<li><span class="pagination__item">...</span></li>');
        return;
      }

      if (part === currentPage) {
        items.push(`
          <li>
            <a
              role="link"
              aria-disabled="true"
              class="pagination__item pagination__item--current light"
              aria-current="page"
              aria-label="Sayfa ${part}"
            >${part}</a>
          </li>
        `);
        return;
      }

      items.push(`
        <li>
          <a
            href="${buildNavigationUrl(part, selectedColorTokens, selectedSizeTokens)}"
            class="pagination__item link"
            aria-label="Sayfa ${part}"
          >${part}</a>
        </li>
      `);
    });

    if (currentPage < totalPages) {
      items.push(`
        <li>
          <a
            href="${buildNavigationUrl(currentPage + 1, selectedColorTokens, selectedSizeTokens)}"
            class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
            aria-label="Sonraki sayfa"
          >
            <span class="svg-wrapper">${window.themeIcons?.caret || ''}</span>
          </a>
        </li>
      `);
    }

    collection.insertAdjacentHTML(
      'beforeend',
      `
        <div class="pagination-wrapper" data-page="${currentPage}">
          <nav class="pagination" role="navigation" aria-label="Sayfalama">
            <ul class="pagination__list list-unstyled" role="list">${items.join('')}</ul>
          </nav>
        </div>
      `,
    );
  };

  const getShowMoreLabels = (container) => ({
    showMore: container.dataset.showMoreLabel || 'Daha fazla göster',
    showLess: container.dataset.showLessLabel || 'Daha az göster',
  });

  const createGroupMarkup = (container, title, type, options, selectedValues) => {
    const details = document.createElement('details');
    details.className = 'custom-facets__details';
    details.open = true;

    const summary = document.createElement('summary');
    summary.className = 'custom-facets__summary';
    summary.textContent = title;
    details.appendChild(summary);

    const display = document.createElement('div');
    display.className = 'custom-facets__display parent-display';

    const list = document.createElement('ul');
    list.className = 'custom-facets__list parent-wrap';

    options.forEach((option, index) => {
      const optionValue = option.token;
      const optionLabel = option.label;

      const item = document.createElement('li');
      item.className = 'custom-facets__item';
      if (index >= SHOW_MORE_LIMIT) {
        item.classList.add('show-more-item', 'hidden');
      }

      const label = document.createElement('label');
      label.className = 'custom-facets__option';

      const input = document.createElement('input');
      input.type = 'checkbox';
      input.value = optionValue;
      input.dataset.customFilterType = type;
      input.checked = selectedValues.includes(optionValue);

      const text = document.createElement('span');
      text.textContent = optionLabel;

      label.appendChild(input);
      label.appendChild(text);
      item.appendChild(label);
      list.appendChild(item);
    });

    display.appendChild(list);

    if (options.length > SHOW_MORE_LIMIT) {
      const labels = getShowMoreLabels(container);
      const showMoreButton = document.createElement('show-more-button');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button-show-more link underlined-link';
      button.id = `Show-More-Custom-${++showMoreIdCounter}`;

      const showMoreLabel = document.createElement('span');
      showMoreLabel.className = 'label-show-more label-text';
      showMoreLabel.innerHTML = `<span aria-hidden="true">+ </span>${labels.showMore}`;

      const showLessLabel = document.createElement('span');
      showLessLabel.className = 'label-show-less label-text hidden';
      showLessLabel.innerHTML = `<span aria-hidden="true">- </span>${labels.showLess}`;

      button.appendChild(showMoreLabel);
      button.appendChild(showLessLabel);
      showMoreButton.appendChild(button);
      display.appendChild(showMoreButton);
    }

    details.appendChild(display);
    return details;
  };

  const matchesFilters = (item, selectedColorTokens, selectedSizeTokens) => {
    const itemColorTokens = splitPipeValues(item.dataset.customColorTokens || '');
    const itemSizeTokens = splitPipeValues(item.dataset.customSizeTokens || '');

    const colorMatch =
      selectedColorTokens.length === 0 || selectedColorTokens.some((token) => itemColorTokens.includes(token));
    const sizeMatch =
      selectedSizeTokens.length === 0 || selectedSizeTokens.some((size) => itemSizeTokens.includes(size));

    return colorMatch && sizeMatch;
  };

  const hydrateItemTokens = (item) => {
    if (item.dataset.customColorTokens && item.dataset.customSizeTokens !== undefined) return;

    const itemColorTokens = new Set();
    const explicitColors = splitPipeValues(item.dataset.customColors || '');

    explicitColors.forEach((colorLabel) => {
      const token = normalize(colorLabel);
      if (!token) return;
      itemColorTokens.add(token);
    });

    if (itemColorTokens.size === 0) {
      const normalizedTitle = normalize(item.dataset.customTitle || '');
      TITLE_COLOR_KEYWORDS.forEach((entry) => {
        if (normalizedTitle.includes(entry.token)) {
          itemColorTokens.add(entry.token);
        }
      });
    }

    item.dataset.customColorTokens = Array.from(itemColorTokens).join('|');

    const sizes = splitPipeValues(item.dataset.customSizes || '');
    item.dataset.customSizeTokens = sizes.map((sizeLabel) => normalizeSizeValue(sizeLabel).token).filter(Boolean).join('|');
  };

  const fetchFilteredItems = async (container, selectedColorTokens, selectedSizeTokens) => {
    const cacheKey = getFilterCacheKey(selectedColorTokens, selectedSizeTokens);
    if (filteredItemsCache.has(cacheKey)) {
      return filteredItemsCache.get(cacheKey);
    }

    const parser = new DOMParser();
    const totalPages = getTotalPages();
    const pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    const responses = await Promise.all(
      pages.map((page) => fetch(getSectionUrl(container, page)).then((response) => response.text())),
    );

    const filteredItems = responses.flatMap((markup) => {
      const doc = parser.parseFromString(markup, 'text/html');
      return Array.from(doc.querySelectorAll('#product-grid [data-custom-filter-item]')).flatMap((item) => {
        hydrateItemTokens(item);
        return matchesFilters(item, selectedColorTokens, selectedSizeTokens) ? [item.outerHTML] : [];
      });
    });

    filteredItemsCache.set(cacheKey, filteredItems);
    return filteredItems;
  };

  const renderFilteredItems = async (container) => {
    const requestId = ++currentRenderRequestId;
    const selectedColorTokens = getSelectedValues(container, 'color');
    const selectedSizeTokens = getSelectedValues(container, 'size');
    const productGrid = document.getElementById('product-grid');

    if (!productGrid) return;

    if (!hasActiveFilters(selectedColorTokens, selectedSizeTokens)) {
      window.location.assign(buildNavigationUrl(1, [], []));
      return;
    }

    const filteredItems = await fetchFilteredItems(container, selectedColorTokens, selectedSizeTokens);
    if (requestId !== currentRenderRequestId) return;

    const productsPerPage = getProductsPerPage(container);
    const totalPages = Math.max(1, Math.ceil(filteredItems.length / productsPerPage));
    const currentPage = Math.min(getCurrentCustomPage(), totalPages);
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentItems = filteredItems.slice(startIndex, startIndex + productsPerPage);

    pauseObserver();

    productGrid.innerHTML = currentItems.length
      ? currentItems.join('')
      : '<li class="popular-products__item border-item grid__item">Filtrelerle eslesen urun bulunamadi.</li>';

    updateProductCounts(filteredItems.length);
    renderPagination(container, filteredItems.length, selectedColorTokens, selectedSizeTokens);
  };

  const initializeContainer = (container) => {
    syncContainerPlacement(container);

    const items = collectItemsForContainer(container);
    if (!items.length) {
      container.innerHTML = '';
      container.hidden = true;
      return;
    }

    const selectedColorTokens = getSelectedValuesFromUrl('color');
    const selectedSizeTokens = getSelectedValuesFromUrl('size');
    const filterData = collectFilterData(items);

    container.innerHTML = '';
    container.hidden = false;

    if (!container._customMobileInputIsolationBound) {
      container.addEventListener(
        'input',
        (event) => {
          if (!event.target.closest('#FacetFiltersFormMobile')) return;
          event.stopPropagation();
        },
        true,
      );
      container._customMobileInputIsolationBound = true;
    }

    if (filterData.colors.length) {
      container.appendChild(createGroupMarkup(container, 'Renk', 'color', filterData.colors, selectedColorTokens));
    }

    if (filterData.sizes.length) {
      container.appendChild(createGroupMarkup(container, 'Ölçü', 'size', filterData.sizes, selectedSizeTokens));
    }

    if (!container._customFiltersBound) {
      container.addEventListener('change', () => {
        const selectedColorTokens = getSelectedValues(container, 'color');
        const selectedSizeTokens = getSelectedValues(container, 'size');

        if (!hasActiveFilters(selectedColorTokens, selectedSizeTokens)) {
          window.location.assign(buildNavigationUrl(1, [], []));
          return;
        }

        history.pushState(
          { searchParams: new URL(buildNavigationUrl(1, selectedColorTokens, selectedSizeTokens), window.location.origin).search.slice(1) },
          '',
          buildNavigationUrl(1, selectedColorTokens, selectedSizeTokens),
        );
        renderFilteredItems(container);
      });
      container._customFiltersBound = true;
    }

    if (!container._customPaginationBound) {
      document.getElementById('ProductGridContainer')?.addEventListener('click', (event) => {
        const paginationLink = event.target.closest('.pagination a[href]');
        if (!paginationLink) return;

        const selectedColorTokens = getSelectedValues(container, 'color');
        const selectedSizeTokens = getSelectedValues(container, 'size');
        if (!hasActiveFilters(selectedColorTokens, selectedSizeTokens)) return;

        event.preventDefault();
        history.pushState(
          { searchParams: new URL(paginationLink.href, window.location.origin).search.slice(1) },
          '',
          paginationLink.href,
        );
        renderFilteredItems(container);
      });
      container._customPaginationBound = true;
    }

    if (hasActiveFilters(selectedColorTokens, selectedSizeTokens)) {
      updateUrlState(container);
      renderFilteredItems(container);
    }
  };

  const initializeAllCustomFilters = () => {
    document.querySelectorAll('.js-custom-facets').forEach((container) => {
      initializeContainer(container);
    });
  };

  let initTimer;
  const scheduleInitialize = () => {
    window.clearTimeout(initTimer);
    initTimer = window.setTimeout(() => {
      initializeAllCustomFilters();
    }, 50);
  };

  const observeProductGridChanges = () => {
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer || gridContainer.dataset.customFiltersObserved === 'true') return;

    const observer = new MutationObserver(() => {
      if (Date.now() < ignoreObserverUntil) return;
      scheduleInitialize();
    });

    observer.observe(gridContainer, { childList: true, subtree: true });
    gridContainer.dataset.customFiltersObserved = 'true';
  };

  const patchFacetsRender = () => {
    if (!window.FacetFiltersForm || window.FacetFiltersForm.__customFiltersPatched) return;

    const originalRenderProductGridContainer = window.FacetFiltersForm.renderProductGridContainer;
    if (typeof originalRenderProductGridContainer !== 'function') return;

    window.FacetFiltersForm.renderProductGridContainer = function patchedRenderProductGridContainer(html) {
      originalRenderProductGridContainer.call(this, html);
      scheduleInitialize();
    };

    window.FacetFiltersForm.__customFiltersPatched = true;
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.themeIcons = window.themeIcons || {};
    if (!window.themeIcons.caret) {
      const caretIcon = document.querySelector('.pagination .svg-wrapper');
      if (caretIcon) window.themeIcons.caret = caretIcon.innerHTML;
    }

    patchFacetsRender();
    observeProductGridChanges();
    scheduleInitialize();
  });

  document.addEventListener('shopify:section:load', () => {
    patchFacetsRender();
    observeProductGridChanges();
    scheduleInitialize();
  });

  window.addEventListener('resize', scheduleInitialize);
  window.addEventListener('popstate', scheduleInitialize);
})();
